import React from 'react';
import { Card, Loading } from '@uma/react-commons/dist/index';
import { ClickableLabel } from '../ManageOrdersSection/styles';

const Loader = (): React.JSX.Element => {
  return (
    <ClickableLabel>
      <Card
        showDivider={false}
        rowsColorChangeEnabled={false}
        childrenStyle={{ align: 'center', marginTop: '16px' }}
      >
        <Loading data-testid="loading" />
      </Card>
    </ClickableLabel>
  );
};

export default Loader;
